const DocumentRefusedIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="document-refused"
  >
    <path
      d="M25.5454 31.8611H2.29186C1.94924 31.8611 1.62065 31.7256 1.37838 31.4845C1.13611 31.2433 1 30.9163 1 30.5752V2.28588C1 1.94484 1.13611 1.61777 1.37838 1.37663C1.62065 1.13548 1.94924 1 2.29186 1H17.7942L26.8372 10.0012V30.5752C26.8372 30.9163 26.7011 31.2433 26.4588 31.4845C26.2166 31.7256 25.888 31.8611 25.5454 31.8611Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 1V10H26"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3301 16.0717L17.5071 23.9664"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5071 16.0717L10.3301 23.9664"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DocumentRefusedIcon;
